import React, { Component } from 'react';
import logo from '../../images/zaddons_logo.png'

export default class NotFound extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
      return (
          <div className="abs-center wd-xl">
            <div className="text-center mb-xl">
                <img src={logo}  alt="" width="200px" height="40px" className="block-center img-rounded" style={{ objectFit: 'cover' }}/>
                <div className="text-lg mb-lg">404</div>
                <p className="lead m0">We couldn't find this page.</p>
                <p>The page you are looking for does not exists.</p>
            </div>
          </div>
      );
  }
}